<div class="attribute-grid">
  <div class="attribute-label">
    <app-copy-to-clipboard
      class="md:pr-4"
      value="{{label}}: {{ value | formatAttributeValue:valuePrefix:valueSuffix }}"
      >
      {{label}}
    </app-copy-to-clipboard>
  </div>
  <div class="relative" (appOutsideClick)="onAccept()">
    <div class="mb-2 border border-solid border-transparent flex items-center w-full rounded md:mb-0 md:min-h-12 md:px-4"
      [class.hover:bg-neutral-4]="!disabled"
      [class.cursor-pointer]="!disabled"
      [class.min-h-12]="!disabled"
      [class.block]="(editActive$ | async) === false"
      [class.hidden]="editActive$ | async"
      [tabindex]="disabled ? -1 : 0"
      (keydown.enter)="setEditActive(true)"
      (click)="setEditActive(true)"
      >

      @if (inputType === 'text') {
        <app-copy-to-clipboard [value]="$any(value | formatAttributeValue)">
          <span [innerHTML]="$any(value | formatAttributeValue) | nl2br"></span>
        </app-copy-to-clipboard>
      } @else {
        <app-copy-to-clipboard value="{{value | formatAttributeValue:valuePrefix:valueSuffix}}">
          {{ value | formatAttributeValue:valuePrefix:valueSuffix }}
        </app-copy-to-clipboard>
      }
      @if (!disabled) {
        <vwui-icon class="absolute top-1/2 transform -translate-y-1/2 right-4 w-4 h-4 text-neutral-1" iconName="vwui-edit"></vwui-icon>
      }
    </div>
    <div
      class="w-full md:-px-4"
      [class.hidden]="(editActive$ | async) === false"
      [class.block]="editActive$ | async"
      >
      @if (inputType !== 'text') {
        <vwui-input class="w-full" #inputElement [type]="inputType" [formControl]="valueControl"
          (focusin)="onInputFocus()" (focusout)="onBlur()" (keydown.enter)="onAccept()">
        </vwui-input>
      }
      @if (inputType === 'text') {
        <vwui-textarea class="w-full" #inputElement [formControl]="valueControl"
        (focusin)="onInputFocus()" (focusout)="onBlur()"></vwui-textarea>
      }
    </div>

    @if (editActive$ | async) {
      <div class="absolute -bottom-1 right-0 transform translate-y-full flex gap-1 z-1"
        >
        <vwui-button class="editable-value-action-btn editable-value-action-btn--cancel" (focusin)="onFocus()" (focusout)="onBlur()" icon="vwui-close" (click)="onCancel()"></vwui-button>
        <vwui-button class="is-primary editable-value-action-btn" icon="vwui-check" (focusin)="onFocus()" (focusout)="onBlur()" (click)="onAccept()"></vwui-button>
      </div>
    }
  </div>
</div>

